<template>
    <material-card class="v-card--material-stats">
        <v-card slot="offset" class="elevation-10 pa-4 dark-gray svg-icon" dark>
            <v-icon size="40" class="svg-icon">{{icons.mdiTimerAlertOutline}}</v-icon>                                    
        </v-card>

        <div class="text-xs-right">
            <p class="category grey--text font-weight-light">{{title}}</p>
            <h3 class="title display-1 font-weight-light">{{timeSpan}}</h3>
        </div>

        <template slot="actions">
            <v-icon color="blue" size="20" class="mr-2">mdi-information-outline</v-icon>
            <span style="color:#000;" class="caption font-weight-light">{{description}}</span> 
        </template>                                      
    </material-card>
</template>

<script>
import { mdiTimerAlertOutline } from '@mdi/js';
import DashboardApi from '@/api/workspace/onboarding/dashboard.js'

import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

export default {
    mixins: [ FormMixin, DateMixin ],     
    data () {
        return {         
            icons:{
                mdiTimerAlertOutline: mdiTimerAlertOutline   
            },
            qtdeVagas: 0,
            timeSpan: "-"
        }
    },
    computed: {  
        title () {
            return this.$t('Views.Onboarding.Dashboard.Resultado.tempo-pendente-aprovacao')
        },
        description () {
            return this.$t('Views.Onboarding.Dashboard.Resultado.media-pendente-aprovacao').replace("{0}", this.qtdeVagas)            
        }        
    },
    async mounted(){       
        const loading = this.showLoading();
        await this.listar();
        loading.close();                
    },
    methods:{  
        async listar(){
            const self = this;
            const dashboard = await DashboardApi.listarTempoPendenteAprovacao(
                this.$route.params.dataInicial, 
                this.$route.params.dataFinal, 
                this.$route.params.idPais
            ).catch(erro => self.showSnackbarError(erro.error));     
            
            if(dashboard.success) {
                if(dashboard.data != null){
                    this.qtdeVagas = dashboard.data.quantidade;
                    let dataInicial = self.$moment();

                    let dataFinal = self.$moment(dataInicial).add(dashboard.data.tempo, 'second');
                    this.timeSpan = this.getTimespan(dataInicial, dataFinal);  
                }
            }
            else {                        
                self.showSnackbarError(dashboard.error);
                throw new Error(dashboard.error[0].userMessage);
            } 
        },            
    }
}
</script>

<style lang="scss"  >
@import "../../../styles/material-dashboard/variables";

.v-card--material-stats {
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: auto;
    padding: 0 16px 0;

    .v-card{
        line-height: 55px !important;
    }

    .dark-gray{
        background-color: #3d3d3d !important;
    }

    .light-gray{
        background-color: #b1b1b1 !important;
    }

    .blue{
        background-color: #1d5cf6 !important;
    }   

    .svg-icon {
        width: 85px;
        margin-left: 5px;
        .v-icon__svg{
            height: 40px !important;
            width: 40px !important;
        }
    }      
  } 

  .v-card {
    border-radius: 4px;
    flex: 0 1 auto;
  }

  .v-card__text {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }

  .v-card__actions {
    flex: 1 0 100%;
  }
}